import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import VueCookies from 'vue-cookies'
import HttpMixin from './mixins/http'
import GlobalMixin from './mixins/global.js'
import RequestStatus from './components/ui/RequestStatus.vue'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueCookies)

Vue.mixin(HttpMixin)
Vue.mixin(GlobalMixin)
Vue.component('request-status', RequestStatus)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
